<template>
  <el-image
    class="image-box flex-center"
    :style="{
      '--scale': scale,
    }"
    :src="src"
    :alt="alt"
    :lazy="lazy"
    :fit="fit">
    <div
      slot="error"
      class="image-slot flex-col-center">
      <i class="el-icon el-icon-picture-outline"></i>
      <div class="image-slot-text">{{ $t('imgError') || '暂无图片' }}</div>
    </div>
  </el-image>
</template>
<script>
export default {
  name: "ylImage",
  props: {
    src: {
      type: String,
      default: "",
    },
    alt: {
      type: String,
      default: "",
    },
    fit: {
      type: String,
      default: "cover",
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    scale: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {};
  },
  created() {},
};
</script>
<style scoped lang="scss">
.image-box {
  width: 100%;
  height: 100%;
  background-color: #f5f7fa;
  transition: transform 0.4s;
  &:hover {
    transform: scale(var(--scale));
  }
}
.image-slot {
  .image-slot-text {
    color: #c0c4cc;
  }
  .el-icon {
    color: #c0c4cc;
    // font-size: 70px;
    font-size: 4.375em;
  }
}
</style>
